import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { DialogSelectCompany } from '../dialogs/DialogSelectCompany';
import LoadingOverlay from '../others/LoadingOverlay';
import { DynamicSelect } from '../dynamicForm/DynamicSelect';
import { MultipleSelect } from '../dynamicForm/MultipleSelect';
import { ensureArray } from '../../utils/validateResponseApi';
import { AUTHORIZER_AUTOMATIC, useFormApproval } from './useFormApproval';

const FormApproval = ({ handleClose, data, item }) => {
    const {
        formData,
        rowData,
        rows,
        loading,
        openDialogCompany,
        companies,
        authorizers,
        fields,
        errorInputs,
        isSupplierView,
        isAutomatic,
        showConnector,
        selectedCondition,
        companyInfo,
        valueSelectField,
        supplierField,
        handleInputChange,
        handleSupplierChange,
        handleRowChange,
        handleAddRow,
        handleEditRow,
        handleDeleteRow,
        handleCancel,
        handleSave,
        handleConfirmAction,
        getConditionLabel,
    } = useFormApproval({ handleClose, data, item });

    const renderValueInput = () => {
        const inputType = selectedCondition?.type || 'text';

        if (inputType === 'select' && selectedCondition?.trigger?.length) {
            return (
                <DynamicSelect
                    field={valueSelectField}
                    companyInfo={companyInfo}
                    formData={rowData}
                    errorInputs={errorInputs}
                    onChange={handleRowChange}
                    handleChanges={(name, value) => handleRowChange({ target: { name, value } })}
                    disabled={!rowData.data_field}
                />
            );
        }

        return (
            <TextField
                fullWidth
                size="small"
                label="Valor"
                name="field_value"
                type={inputType === 'number' ? 'number' : 'text'}
                value={rowData.field_value}
                onChange={handleRowChange}
                error={!!errorInputs.field_value?.isError}
                helperText={errorInputs.field_value?.messageError}
                required
                disabled={!rowData.data_field}
            />
        );
    };

    return (
        <>
            <Box sx={{ width: '90%', mx: 'auto' }}>
                <Typography variant="h6">Reglas Aprobacion</Typography>
                <Card sx={{ mb: 3 }}>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 3 }}>
                                <FormControl>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                name="required"
                                                checked={Boolean(formData.required)}
                                                onChange={handleInputChange}
                                            />
                                        }
                                        label="Obligatorio"
                                    />
                                </FormControl>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 3 }}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Prioridad"
                                    name="priority"
                                    value={formData.priority}
                                    onChange={handleInputChange}
                                    error={!!errorInputs.priority?.isError}
                                    helperText={errorInputs.priority?.messageError}
                                    required
                                    type="number"
                                />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 3 }}>
                                <FormControl
                                    fullWidth
                                    size="small"
                                    error={Boolean(errorInputs.type_authorizer?.isError)}
                                    required
                                >
                                    <InputLabel id="type_authorizer">Tipo de Autorizador</InputLabel>
                                    <Select
                                        label="Tipo Autorizador"
                                        name="type_authorizer"
                                        value={formData.type_authorizer}
                                        onChange={handleInputChange}
                                    >
                                        <MenuItem value={AUTHORIZER_AUTOMATIC}>Automático</MenuItem>
                                        <MenuItem value="group">Grupo</MenuItem>
                                        <MenuItem value="user">Usuario</MenuItem>
                                    </Select>
                                    {errorInputs.type_authorizer?.isError && (
                                        <FormHelperText>{errorInputs.type_authorizer.messageError}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 3 }}>
                                <FormControl
                                    fullWidth
                                    size="small"
                                    error={Boolean(errorInputs.id_authorizer?.isError)}
                                    required={!isAutomatic}
                                >
                                    <InputLabel id="id_authorizer">ID Autorizador</InputLabel>
                                    <Select
                                        label="ID Autorizador"
                                        name="id_authorizer"
                                        value={formData.id_authorizer || ''}
                                        onChange={handleInputChange}
                                        disabled={!formData.type_authorizer || isAutomatic}
                                    >
                                        {authorizers.map((authorizer) => (
                                            <MenuItem key={authorizer.id} value={authorizer.id}>
                                                {authorizer.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {errorInputs.id_authorizer?.isError && (
                                        <FormHelperText>{errorInputs.id_authorizer.messageError}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            {!isSupplierView && (
                                <Grid size={{ xs: 12 }}>
                                    {formData.id_company ? (
                                        <MultipleSelect
                                            field={supplierField}
                                            companyInfo={companyInfo}
                                            values={ensureArray(formData.id_supplier)}
                                            errorInputs={errorInputs}
                                            handleChange={handleSupplierChange}
                                            label="Proveedor"
                                        />
                                    ) : (
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Proveedor"
                                            disabled
                                            value=""
                                            helperText="Seleccione una empresa para cargar los proveedores"
                                        />
                                    )}
                                </Grid>
                            )}
                        </Grid>

                        <Box sx={{ height: '5px', mt: 4, mb: 4, background: 'linear-gradient(to right, #6728AF 50%, #84858a 50%)' }}></Box>

                        <Box>
                            <Grid container spacing={2} alignItems="center">
                                <Grid size={{ xs: 12, sm: showConnector ? 4 : 5 }}>
                                    <FormControl
                                        fullWidth
                                        size="small"
                                        error={Boolean(errorInputs.data_field?.isError)}
                                        required
                                    >
                                        <InputLabel id="data_field">Condición</InputLabel>
                                        <Select
                                            label="Condición"
                                            name="data_field"
                                            value={rowData.data_field}
                                            onChange={handleRowChange}
                                        >
                                            {fields.map((fl) => (
                                                <MenuItem key={fl.code} value={fl.code}>
                                                    {fl.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {errorInputs.data_field?.isError && (
                                            <FormHelperText>{errorInputs.data_field.messageError}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>

                                <Grid size={{ xs: 12, sm: showConnector ? 4 : 5 }}>
                                    {renderValueInput()}
                                </Grid>

                                {showConnector && (
                                    <Grid size={{ xs: 12, sm: 3 }}>
                                        <FormControl
                                            fullWidth
                                            size="small"
                                            error={Boolean(errorInputs.connector?.isError)}
                                            required
                                        >
                                            <InputLabel id="connector">Conector</InputLabel>
                                            <Select
                                                label="Conector"
                                                name="connector"
                                                value={rowData.connector}
                                                onChange={handleRowChange}
                                            >
                                                <MenuItem value="AND">AND</MenuItem>
                                                <MenuItem value="OR">OR</MenuItem>
                                            </Select>
                                            {errorInputs.connector?.isError && (
                                                <FormHelperText>{errorInputs.connector.messageError}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                )}

                                <Grid size={{ xs: 12, sm: 1 }}>
                                    <IconButton color="primary" onClick={handleAddRow}>
                                        <AddIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Box>

                        <Box mt={4}>
                            <Typography variant="h6">Condiciones agregadas</Typography>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Condición</TableCell>
                                        <TableCell>Valor</TableCell>
                                        <TableCell>Conector</TableCell>
                                        <TableCell>Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, index) => (
                                        <TableRow key={`${row.data_field}-${index}`}>
                                            <TableCell>{getConditionLabel(row.data_field)}</TableCell>
                                            <TableCell>{row.field_value}</TableCell>
                                            <TableCell>{row.connector || '-'}</TableCell>
                                            <TableCell>
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => handleEditRow(index)}
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                                <IconButton
                                                    color="secondary"
                                                    onClick={() => handleDeleteRow(index)}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>

                        <Box sx={{ textAlign: 'right', mt: 4 }}>
                            <Button
                                onClick={handleCancel}
                                variant="contained"
                                color="primary"
                                sx={{ mx: 2 }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={handleSave}
                            >
                                Guardar
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
            {!formData?.id_company &&
                <DialogSelectCompany
                    openDialogConfirm={openDialogCompany}
                    handleCancelConfirm={handleCancel}
                    handleConfirmAction={handleConfirmAction}
                    data={companies}
                    titleDialog={'Empresa a la cual se le creara la regla'}
                />
            }
            <LoadingOverlay isOpen={loading} />
        </>
    );
};

export default FormApproval;
